import { createSlice } from '@reduxjs/toolkit';

export const shippingInfo = createSlice({
  name: 'shippingInfo',
  initialState: {
    data: [],
  },

  reducers: {
    setShippingInfo: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setShippingInfo } = shippingInfo.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getShippingInfo = (state) => state.shippingInfo.data;

export default shippingInfo.reducer;
